import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  mergeUsersService,
  verifyOtpMergeSevice,
  resendOtpMergeSevice,
  mergeUsersLogoutService,
} from "../../services/accountMerge";

export const accountMerge = createAsyncThunk(
  "users/mergeUsers",
  async (obj, { rejectWithValue }) => {
    const {
      email,
      mobile_otp_message_id,
      email_otp_message_id,
      mobile_otp,
      email_otp,
      token,
    } = obj;
    try {
      const response = await mergeUsersService(
        {
          email,
          mobile_otp_message_id,
          email_otp_message_id,
          mobile_otp,
          email_otp,
        },
        token
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const sendOtpMerge = createAsyncThunk(
  "users/sendOtp",
  async (obj, { rejectWithValue }) => {
    const { email, token } = obj;
    try {
      const response = await verifyOtpMergeSevice({ email }, token);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const resendOtpMerge = createAsyncThunk(
  "users/resendOtp",
  async (obj, { rejectWithValue }) => {
    const { mobile_otp_message_id, email_otp_message_id, token } = obj;
    try {
      const response = await resendOtpMergeSevice(
        {
          mobile_otp_message_id,
          email_otp_message_id,
        },
        token
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const mergeUsersLogout = createAsyncThunk(
  "users/mergeUsersLogout",
  async (obj, { rejectWithValue }) => {
    const { token } = obj;
    try {
      const response = await mergeUsersLogoutService(token);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
const initialState = {
  list: {
    data: [],
    error: null,
    status: null,
  },
  verifyOtpMergeSevice: {
    data: null,
    error: null,
    status: null,
  },
  mergeUsersLogoutService: {
    data: null,
    error: null,
    status: null,
  },
};

export const accountMergeSlice = createSlice({
  name: "accountMerge",
  initialState: initialState,
  reducers: {
    resetMobileMsgId: (state) => {
      state.verifyOtpMergeSevice = {
        ...state.verifyOtpMergeSevice,
        status: null,
        error: null,
        data: null,
      };
    },
    resetEmailMsgId: (state) => {
      state.resendOtpMergeSevice = {
        ...state.resendOtpMergeSevice,
        status: null,
        error: null,
        data: null,
      };
    },
    resetAccountMerge: (state) => {
      state.list = {
        ...state.list,
        status: null,
        error: null,
        data: null,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(accountMerge.pending, (state, action) => {
        state.list = { ...state.list, status: "loading" };
      })
      .addCase(accountMerge.fulfilled, (state, action) => {
        state.list = {
          ...state.list,
          status: "succeeded",
          data: action.payload,
          error: null,
        };
      })
      .addCase(accountMerge.rejected, (state, action) => {
        state.list = {
          ...state.list,
          status: "failed",
          error: action.payload,
          data: [],
        };
      })

      .addCase(sendOtpMerge.pending, (state, action) => {
        state.verifyOtpMergeSevice = { ...state.verifyOtpMergeSevice, status: "loading" };
      })
      .addCase(sendOtpMerge.fulfilled, (state, action) => {
        state.verifyOtpMergeSevice = {
          ...state.verifyOtpMergeSevice,
          ...state.resendOtpMergeSevice,
          status: "succeeded",
          data: action.payload,
          error: null,
        };
      })
      .addCase(sendOtpMerge.rejected, (state, action) => {
        state.verifyOtpMergeSevice = {
          ...state.verifyOtpMergeSevice,
          ...state.resendOtpMergeSevice,
          status: "failed",
          error: action.payload,
          data: [],
        };
      })

      .addCase(mergeUsersLogout.pending, (state, action) => {
        state.mergeUsersLogoutService = {
          ...state.mergeUsersLogoutService,
          status: "loading",
        };
      })
      .addCase(mergeUsersLogout.fulfilled, (state, action) => {
        state.mergeUsersLogoutService = {
          ...state.mergeUsersLogoutService,
          status: "succeeded",
          data: action.payload,
          error: null,
        };
      })
      .addCase(mergeUsersLogout.rejected, (state, action) => {
        state.mergeUsersLogoutService = {
          ...state.mergeUsersLogoutService,
          status: "failed",
          error: action.payload,
          data: [],
        };
      });
  },
});

export const { resetMobileMsgId, resetEmailMsgId ,resetAccountMerge} = accountMergeSlice.actions;

export default accountMergeSlice.reducer;
